import axiosClient from "./axiosClient";
import { unwrapApiResponse } from "../utils/apiResponse";

/**
 * Public content API — returns PublicPageDto directly (no admin envelope).
 * Sends language as query + Accept-Language / X-Language headers.
 */
export const getPublicPage = async (slug, language = "en") => {
  const lang = (language || "en").toLowerCase();

  const response = await axiosClient.get(`/api/content/pages/${slug}`, {
    params: { language: lang },
    headers: {
      "Accept-Language": lang,
      "X-Language": lang,
    },
  });

  return unwrapApiResponse(response);
};

export const getPublicBlogPosts = async (language = "en", { home, take } = {}) => {
  const lang = (language || "en").toLowerCase();
  const response = await axiosClient.get("/api/content/blog", {
    params: {
      language: lang,
      ...(home != null ? { home } : {}),
      ...(take != null ? { take } : {}),
    },
    headers: {
      "Accept-Language": lang,
      "X-Language": lang,
    },
  });
  return unwrapApiResponse(response);
};

export const getPublicBlogPost = async (slugOrId, language = "en") => {
  const lang = (language || "en").toLowerCase();
  const response = await axiosClient.get(`/api/content/blog/${slugOrId}`, {
    params: { language: lang },
    headers: {
      "Accept-Language": lang,
      "X-Language": lang,
    },
  });
  return unwrapApiResponse(response);
};
